const DEFAULT_FILLED_INPUT_CLASS_NAME = 'default-filled-input';

export default DEFAULT_FILLED_INPUT_CLASS_NAME;
